/* External dependencies */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

/* Local dependencies */
import { RootState, useAppDispatch } from '../../../redux/store';
import { initClient } from './redux/auth-actions';

interface SessionInitializerProps {
  children: React.ReactNode;
}

export function SessionInitializer(props: SessionInitializerProps) {
  const { children } = props;

  const { initializing } = useSelector((state: RootState) => state.auth);
  
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (initializing) {
      dispatch(initClient());
    }
  }, [initializing]);

  return <>{children}</>;
}
